// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldBlock__dezGy {
  width: 100%;
  position: relative;
}

.fieldLabel__rAGK1 {
  font-size: 11px;
  font-weight: 400;
  line-height: 12px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
  min-height: 20px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.extraLabel__hiBDZ {
  font-size: 11px;
  line-height: 12px;
  color: var(--tables-primary-row-text-additional);
  margin-top: 6px;
}

.textareaField__JtpOC {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--inputs-filled-text);
  min-height: 100px;
  padding: 25px;
  border: 1px solid var(--inputs-filled-stroke);
  background: var(--inputs-filled-filled-surface);
  border-radius: 5px;
  overflow-y: auto;
}
.textareaField__JtpOC::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.textareaField__JtpOC::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.textareaField__JtpOC::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.textareaField__JtpOC::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
.textareaField__JtpOC > * {
  line-height: 18px;
}
.textareaField__JtpOC p {
  margin: 0;
}
.textareaField__JtpOC img {
  width: 100% !important;
  height: 100%;
  object-fit: cover;
  display: block;
  cursor: zoom-in;
  margin-top: 15px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/TextareaFieldComponent/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,6CAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;AAzEF;AAVE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAYJ;AATE;EACE,+BAAA;EACA,kBAAA;AAWJ;AARE;EACE,8BAAA;EACA,kBAAA;AAUJ;AAPE;EACE,gBAAA;EACA,kBAAA;AASJ;AA4DE;EACE,iBAAA;AA1DJ;AA8DI;EACE,SAAA;AA5DN;AA+DI;EACE,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA7DN","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.fieldBlock {\n  width: 100%;\n  position: relative;\n}\n\n.fieldLabel {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n  min-height: 20px;\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.extraLabel {\n  font-size: 11px;\n  line-height: 12px;\n  color: var(--tables-primary-row-text-additional);\n  margin-top: 6px;\n}\n\n.textareaField {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--inputs-filled-text);\n  min-height: 100px;\n  padding: 25px;\n  border: 1px solid var(--inputs-filled-stroke);\n  background: var(--inputs-filled-filled-surface);\n  border-radius: 5px;\n  overflow-y: auto;\n\n  @include scrollBar;\n\n  & > * {\n    line-height: 18px;\n  }\n\n  :global {\n    p {\n      margin: 0;\n    }\n\n    img {\n      width: 100% !important;\n      height: 100%;\n      object-fit: cover;\n      display: block;\n      cursor: zoom-in;\n      margin-top: 15px;\n      margin-bottom: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldBlock": `fieldBlock__dezGy`,
	"fieldLabel": `fieldLabel__rAGK1`,
	"extraLabel": `extraLabel__hiBDZ`,
	"textareaField": `textareaField__JtpOC`
};
module.exports = ___CSS_LOADER_EXPORT___;
